import type { FC, FormEventHandler } from 'react';
import { useEffect, useState } from 'react';
import { OldInput } from '@ui';

import { validationEmail } from '@utils/validation';
import './index.scss';
import { observer } from 'mobx-react';
import AuthFormBtn from '@components/AuthForm/components/AuthFormBtn';

interface AuthFormRestorePassProps {
  resetPass: any;
  getUserCredentials: any;
  goToMainStage: any;
  userEmail: string;
}

const AuthFormRestorePass: FC<AuthFormRestorePassProps> = ({
  resetPass,
  getUserCredentials,
  goToMainStage,
  userEmail
}) => {
  const [formData, setFormData] = useState({
    text: { value: userEmail || '', error: '' }
  });
  const [hasPassBeenRestored, setHasPassBeenRestored] = useState(false);

  useEffect(() => {
    if (userEmail) {
      setFormData(prev => ({
        ...prev,
        text: { ...prev.text, value: userEmail }
      }));
    }
  }, [userEmail]);

  const getInputData = ({
    value,
    error
  }: {
    name: string;
    value: string;
    error?: string;
  }): void => {
    setFormData(prev => ({ ...prev, text: { value, error: error || '' } }));
  };

  const onBtnClickHandler = (): void => {
    const inputValue = formData.text.value;
    const isInputValidEmail = validationEmail(inputValue);
    if (isInputValidEmail) {
      getUserCredentials({ field: 'email', value: inputValue });
      resetPass(inputValue);
      setHasPassBeenRestored(true);
    } else {
      setFormData({ ...formData, text: { ...formData.text, error: 'Ошибка' } });
    }
  };
  const onSubmit: FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault();
  };
  return (
    <form onSubmit={onSubmit}>
      {!hasPassBeenRestored ? (
        <>
          {' '}
          <div className='AuthForm__heading'>Восстановление пароля</div>
          <OldInput
            className='mb-6 text-center'
            placeholder='E-mail'
            autoComplete='on'
            getInputData={getInputData}
            field='text'
            name='email-pass'
            value={formData.text.value}
            error={formData.text.error}
          />
          <AuthFormBtn onClick={onBtnClickHandler}>
            Восстановить пароль
          </AuthFormBtn>
          <div className='AuthForm__text-btn' onClick={goToMainStage}>
            Я помню пароль
          </div>
        </>
      ) : (
        <>
          <div className='AuthForm__heading'>Отлично!</div>
          <div className='AuthFormRestorePass__text'>
            Мы отправили новый пароль на {userEmail} Используйте его для входа.
            Поменять пароль можно в личном кабинете в разделе «Личные данные»{' '}
          </div>
          <AuthFormBtn onClick={goToMainStage}>Понятно, спасибо</AuthFormBtn>
        </>
      )}
    </form>
  );
};

export default observer(AuthFormRestorePass);
